import { JWPlayerConfig } from '@src/modules/players/shared/interfaces/player-configs.interface';
import { openSwal } from '@root/private/js/common/securekey/util';
import axios from 'axios';

declare const _playerOptions: JWPlayerConfig;

export const setExtraSecure = async (action: string, label: string) => {
  if (action.includes('c')) {
    const concurrencyResult = await preventConcurrentPlay(label);

    if (!concurrencyResult) {
      await openSwal({
        icon: 'error',
        title: '중복 재생 감지',
        message: '중복 재생이 감지되어 재생이 불가능합니다.',
      });
    }
  }

  if (action.includes('w')) {
    _playerOptions.customOption.watermark = {
      ..._playerOptions.customOption.watermark,
      enable: true,
      label,
    };
  }
};

const preventConcurrentPlay = async (label: string): Promise<boolean> => {
  const { data: validation } = await axios.get(
    `/validate?uuid=${_playerOptions.x_midibus_uuid}&label=${label}&channelId=${_playerOptions.x_midibus_ch_id}`,
  );

  if (!validation) {
    return validation;
  }

  const playData = {
    channelId: _playerOptions.x_midibus_ch_id,
    uuid: _playerOptions.x_midibus_uuid,
    label: label,
  };

  await axios.post(`/validate`, playData);
  window.addEventListener('unload', (e) => {
    const blobPlayerLog = new Blob(
      [JSON.stringify({ ...playData, isFinish: true })],
      {
        type: 'application/json; charset=UTF-8',
      },
    );
    navigator.sendBeacon(`/validate`, blobPlayerLog);
  });

  let updatePlaydataInterval = null;
  try {
    updatePlaydataInterval = setInterval(async () => {
      await axios.post(`/validate`, playData);
    }, 10000);
    return true;
  } catch (err) {
    console.error(err);
    clearInterval(updatePlaydataInterval);
    return true;
  }
};
